module.exports = __webpack_public_path__ + "static/media/img1.34ac7417.jpg";